"use client";

import { trackPhoneClick } from "@homeinstead/analytics";
import { Link } from "~care/components/ui/Link/Link";
import { shallowStrings } from "~care/components/ui/NavigationMenu/PPC/navigation-strings";

export function NavigationPhoneCTA({
  phoneNumber,
  formattedPhoneNumber,
}: {
  phoneNumber: string;
  formattedPhoneNumber: string;
}) {
  return (
    <Link
      className="bg-friendly-base px-2 text-new-beginnings-base [@media(min-width:480px)]:px-4"
      href={`tel:${phoneNumber}`}
      onClick={() => trackPhoneClick({ placement: "header" })}
      variant="primary"
    >
      <span className="hidden [@media(min-width:375px)]:inline-block [@media(min-width:440px)]:hidden">
        {shallowStrings.call}
      </span>
      <span className="hidden [@media(min-width:440px)]:inline-block [@media(min-width:480px)]:hidden">
        {shallowStrings.callNow}
      </span>
      <span className="hidden [@media(min-width:480px)]:inline-block">
        {shallowStrings.callUsNow}
      </span>
      <span className="inline-block pl-[2px]">{formattedPhoneNumber}</span>
    </Link>
  );
}
